
















import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Track } from '@/classes/track'
import { LibraryMixin, HistoryViewMixin } from '@/mixins'
import { IColumnDef } from '@/interfaces/ag-grid'
import { TrackFields } from '@/constants'
import { dateCellRenderer } from '@/helpers/ag-grid/cellRenderer'
import { isAfter, subMonths } from 'date-fns'

@Component({
  components: {
    ReorderTable: require('@/components/ReorderTable').default
  }
})
export default class Recent extends Mixins(LibraryMixin, HistoryViewMixin) {
  @Prop({
    default: 'Continue'
  })
  confirmLabel: string

  selectedTracks: Track[] = []

  columnDefs: IColumnDef[] = [
    {
      field: TrackFields.DateImported,
      cellRenderer: dateCellRenderer,
      width: 80
    },
    {
      field: TrackFields.Title
    },
    {
      field: TrackFields.Artist
    }
  ]

  get tracks(): Track[] {
    if (!this.library) return []

    return this.library.tracks
      .filter(t => isAfter(new Date(t.dateImported), subMonths(new Date(), 1)))
      .sort((a, b) => b.dateImported.localeCompare(a.dateImported))
  }

  async next() {
    this.$emit('confirm', this.selectedTracks)
  }
}
